<script>
	import { fade, fly } from 'svelte/transition'
	import { sineOut } from 'svelte/easing'
	import { loadImage } from '../util/util'

	export let team = []

	let activeTeamMember = team[0]

	let width
	let height = 0
	let animateheight
	let loadedImages = []

	let circleRowWidth = 0

	const setActiveTeamMember = teamMember => (activeTeamMember = teamMember)

	function setHeight(node) {
		function update() {
			if (height !== node.clientHeight) {
				height = node.clientHeight
			}
			if (!animateheight) {
				setTimeout(() => {
					animateheight = true
				}, 0)
			}
		}
		update()
		return {
			update,
		}
	}

	function maskIn(node, { duration, delay, easing, reverse }) {
		return {
			delay,
			duration,
			css: t => {
				const eased = (easing ? easing : cubicInOut)(t)
				const amt = eased * 200
				return `-webkit-mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 1) ${amt -
					100}%, transparent ${amt}%)`
			},
		}
	}
</script>

<div class="team-circles" data-no-panel>
	<div class="tcline" style="min-width: {circleRowWidth}px" />
	<div class="tc-inner">
		<div bind:clientWidth={circleRowWidth}>
			{#each team as teamMember}
				<div
					class="team-circle"
					class:active={teamMember === activeTeamMember}
					on:mouseenter={() => loadImage(teamMember.actionShot)}>
					<div style="background-image:url({teamMember.image})" />
					<button on:click={() => setActiveTeamMember(teamMember)}>
						<span class="sr-only">{teamMember.name}</span>
					</button>
				</div>
			{/each}
		</div>
	</div>
</div>

<div
	class="team-content"
	class:animateheight
	style="padding-bottom:{height}px"
	bind:clientWidth={width}>
	{#each [activeTeamMember] as teamMember (teamMember.name)}
		<div
			class="team-content-inner"
			use:setHeight={width}
			in:maskIn={{ duration: 750, easing: sineOut }}
			out:fade={{ duration: 1, delay: 749 }}>
			<div class="tc-name" out:fade={{ duration: 230 }}>
				<div class="main">
					<div class="inner-wrap">
						<h2>{teamMember.name}</h2>
						<h3>{teamMember.position}</h3>
					</div>
				</div>
			</div>
			<div class="tc-content">
				<div
					class="tc-background"
					style="background-image:url({teamMember.actionShot})" />
				<div class="main">
					<div class="inner-wrap">
						<div class="tc-content-inner">
							{@html teamMember.content}
						</div>
						<a href="/contact/" class="pointer-link">Request Appointment</a>
					</div>
				</div>
			</div>
		</div>
	{/each}
</div>
